import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { SET_CURRENT_PAGE, SET_LAST_PAGE, SET_FIRST_PAGE, SET_PREV_PAGE, SET_NEXT_PAGE, SET_PAGE_SIZE, SET_CLIENT_PAGINATION_STATE, INITIAL_STATE, SET_SERVER_PAGINATION_STATE, LAST, FIRST, PREV, NEXT } from './constants.js';
import { getPageWithRange, getChangedPageSize, getValidCurrentPage, getTotalPages, getItemRange } from './helpers.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var paginationReducer = function paginationReducer(state, action) {
  switch (action.type) {
    case SET_SERVER_PAGINATION_STATE:
      {
        var _action$payload = action.payload,
          currentPage = _action$payload.currentPage,
          pageSize = _action$payload.pageSize,
          pageSizeOptions = _action$payload.pageSizeOptions,
          totalItems = _action$payload.totalItems;
        var totalPages = getTotalPages(totalItems, pageSize);
        var selectedPageSize = pageSize || INITIAL_STATE.pageSize;
        if (state.initialized) {
          if (!totalItems || !currentPage) {
            console.error("Hey Canvas User! Server-side table pagination requires prop values for currentPage & totalItems");
          }
        }
        return _objectSpread(_objectSpread({}, action.payload), {}, {
          initialized: true,
          itemRange: getItemRange({
            page: currentPage,
            pageSize: selectedPageSize,
            totalItems: totalItems,
            totalPages: totalPages
          }),
          pageSize: selectedPageSize,
          pageSizeOptions: pageSizeOptions || INITIAL_STATE.pageSizeOptions,
          totalPages: totalPages
        });
      }
    case SET_CLIENT_PAGINATION_STATE:
      {
        var _action$payload2 = action.payload,
          hidePageSize = _action$payload2.hidePageSize,
          hidePaginationNavigation = _action$payload2.hidePaginationNavigation,
          hideShowItems = _action$payload2.hideShowItems,
          initialPageSize = _action$payload2.initialPageSize,
          isClient = _action$payload2.isClient,
          onPageSizeChange = _action$payload2.onPageSizeChange,
          onRequestFirst = _action$payload2.onRequestFirst,
          onRequestLast = _action$payload2.onRequestLast,
          onRequestPrev = _action$payload2.onRequestPrev,
          onRequestNext = _action$payload2.onRequestNext,
          _pageSize = _action$payload2.pageSize,
          _pageSizeOptions = _action$payload2.pageSizeOptions,
          _totalItems = _action$payload2.totalItems;
        var _selectedPageSize = _pageSize || initialPageSize || !_pageSizeOptions && INITIAL_STATE.pageSize;
        var _totalPages = getTotalPages(_totalItems, _selectedPageSize);
        return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, onPageSizeChange && {
          onPageSizeChange: onPageSizeChange
        }), onRequestNext && {
          onRequestNext: onRequestNext
        }), onRequestPrev && {
          onRequestPrev: onRequestPrev
        }), onRequestFirst && {
          onRequestFirst: onRequestFirst
        }), onRequestLast && {
          onRequestLast: onRequestLast
        }), {}, {
          currentPage: getValidCurrentPage(state === null || state === void 0 ? void 0 : state.currentPage, _totalPages),
          hidePageSize: hidePageSize,
          hidePaginationNavigation: hidePaginationNavigation,
          hideShowItems: hideShowItems,
          isClient: isClient,
          pageSizeOptions: _pageSizeOptions || INITIAL_STATE.pageSizeOptions,
          totalItems: _totalItems,
          totalPages: getTotalPages(_totalItems, _selectedPageSize)
        }, getPageWithRange(_objectSpread(_objectSpread({}, state), {}, {
          currentPage: getValidCurrentPage(state === null || state === void 0 ? void 0 : state.currentPage, _totalPages),
          pageSize: _selectedPageSize,
          totalItems: _totalItems,
          totalPages: _totalPages
        })));
      }
    case SET_PAGE_SIZE:
      {
        return _objectSpread(_objectSpread({}, state), getChangedPageSize(state, Number(action.payload)));
      }
    case SET_NEXT_PAGE:
      {
        return _objectSpread(_objectSpread({}, state), getPageWithRange(state, NEXT));
      }
    case SET_PREV_PAGE:
      {
        return _objectSpread(_objectSpread({}, state), getPageWithRange(state, PREV));
      }
    case SET_FIRST_PAGE:
      {
        return _objectSpread(_objectSpread({}, state), getPageWithRange(state, FIRST));
      }
    case SET_LAST_PAGE:
      {
        return _objectSpread(_objectSpread({}, state), getPageWithRange(state, LAST));
      }
    case SET_CURRENT_PAGE:
      {
        var newPage = Number(action.payload);
        return _objectSpread(_objectSpread({}, state), {}, {
          currentPage: newPage
        }, getPageWithRange(_objectSpread(_objectSpread({}, state), {}, {
          currentPage: newPage
        })));
      }
    default:
      return state;
  }
};

export { paginationReducer as default };
